import { useState, useEffect } from 'react';
import Papa from 'papaparse';

const useProducts = (csvUrl) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('Todas');
  const [searchTerm, setSearchTerm] = useState('');
  const [showOnlyWithImage, setShowOnlyWithImage] = useState(true); // ← NUEVO

  // Función para verificar si una imagen existe
  const checkImageExists = (codigo) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = `${process.env.PUBLIC_URL}/images/${codigo}.webp`;
    });
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await fetch(csvUrl);
        const csvText = await response.text();
        
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: async (results) => {  // ← Cambiado a async
            const productsData = results.data.map(product => ({
              codigo: product.code || product.Codigo || product.CÓDIGO,
              nombre: product.name || product.Nombre || product.NOMBRE,
              unidad: product.unit || product.Unidad || product.UNIDAD,
              precio: parseFloat(product.price || product.Precio || product.PRECIO),
              pv_usd: parseFloat(product.price_usd || product.pv_usd || product.pv_usd),
              cantidad: parseInt(product.quantity || product.Cantidad || product.CANTIDAD),
              familia: product.category || product.Familia || product.FAMILIA,
              disponible: (parseInt(product.quantity || product.Cantidad || product.CANTIDAD) > 0)
            }));
            
            // Verificar qué productos tienen imagen
            const productsWithImageStatus = await Promise.all(
              productsData.map(async (product) => ({
                ...product,
                hasImage: await checkImageExists(product.codigo)
              }))
            );
            
            setProducts(productsWithImageStatus);
            setFilteredProducts(productsWithImageStatus);
            
            // Extraer categorías únicas
            const uniqueCategories = ['Todas', ...new Set(productsWithImageStatus.map(p => p.familia).filter(Boolean))];
            
            setCategories(uniqueCategories);
            setLoading(false);
          }
        });
      } catch (err) {
        setError('Error al cargar los productos');
        setLoading(false);
      }
    };
    
    fetchProducts();
  }, [csvUrl]);

  // Filtrar productos cuando cambian los filtros
  useEffect(() => {
    let filtered = products;
    
    // Filtrar por imagen (solo si showOnlyWithImage está activado)
    if (showOnlyWithImage) {
      filtered = filtered.filter(product => product.hasImage === true);
    }
    
    // Filtrar por categoría
    if (selectedCategory !== 'Todas') {
      filtered = filtered.filter(product => product.familia === selectedCategory);
    }
    
    // Filtrar por búsqueda
    if (searchTerm.trim()) {
      filtered = filtered.filter(product => 
        product.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.codigo?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    setFilteredProducts(filtered);
  }, [selectedCategory, searchTerm, products, showOnlyWithImage]); // ← Agregado showOnlyWithImage

  return {
    products: filteredProducts,
    allProducts: products,
    loading,
    error,
    categories,
    selectedCategory,
    setSelectedCategory,
    searchTerm,
    setSearchTerm,
    showOnlyWithImage,     // ← NUEVO
    setShowOnlyWithImage   // ← NUEVO
  };
};

export default useProducts;